import React from "react";
import styles from "./LoadMoreButton.module.scss";
import assetLoader from "@utils/internalImageLoder";
import Button from "../Button";
import ImageAtom from "../Image";

interface LoadMoreButtonProps {
  onClick: () => void;
}

export const LoadMoreButton: React.FC<LoadMoreButtonProps> = ({ onClick }) => {
  return (
    <Button onClick={onClick} className={styles["load-more"]}>
      <span className={styles["load-more__text"]}>Load more images</span>
      <ImageAtom
        src={`${assetLoader()}/down-arrow.svg`}
        alt="Load more icon"
        width={24}
        height={24}
        className={styles["load-more__icon"]}
      />
    </Button>
  );
};
